import React, { useState } from "react";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { useSelector } from "react-redux";
import { Scatter } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import moment from "moment-timezone";
import { CTooltip } from "@coreui/react";
import InfoIcon from "../../../../assets/icons/info.svg";

const JournalAnalysis = (props) => {
  const { assessmentsData } = useSelector((state) => state.assessment);
  ChartJS.register(
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    TimeScale
  );

  const a_data = [];
  const nm_data = [];
  const d_data = [];
  const pm_data = [];
  const nl_data = [];
  const yAxis = [];

  const sortedResults = assessmentsData?.journal
    ?.slice()
    .sort((a, b) => new Date(a.created) - new Date(b.created));
  const getxData = () => {
    const xData = [];
    sortedResults && sortedResults.forEach((element, index) => {
      xData[index] = moment(element.created).format("MMM DD").toString();
    });
    return xData;
  };

  sortedResults && sortedResults.forEach((element, index) => {
    if (element.nlp_results.length > 0) {
      if (element.nlp_results[0].predicted_label === "positive_mood") {
        pm_data[index] = 20;
        yAxis[index] = 20;
      } else if (element.nlp_results[0].predicted_label === "depression") {
        d_data[index] = 10;
        yAxis[index] = 10;
      } else if (element.nlp_results[0].predicted_label === "anxiety") {
        a_data[index] = 5;
        yAxis[index] = 5;
      } else if (element.nlp_results[0].predicted_label === "negative_mood") {
        nm_data[index] = 15;
        yAxis[index] = 15;
      }
    } else {
      nl_data[index] = 0;
      yAxis[index] = 0;
    }
  });
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label;
            return ` ${context.label},${label}`;
          },
        },
      },
    },

    // Modify the axis by adding scales
    scales: {
      // to remove the labels
      x: {
        type: "category",
        labels: getxData(),
        // to remove the x-axis grid
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      // to remove the y-axis labels
      y: {
        type: "linear",
        max: 40,
        labels: yAxis,
        ticks: {
          display: false,
          beginAtZero: true,
        },
        // to remove the y-axis grid
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
  };

  const data = {
    labels: getxData(),
    datasets: [
      {
        label: "Depression",
        data: d_data,
        pointRadius: 10, // Set the size of the points
        pointStyle: "rectRounded", // Set the shape of the points
        pointHoverRadius: 20,
        backgroundColor: "#FA8581",
      },
      {
        label: "Anxiety",
        data: a_data,
        pointRadius: 10,
        pointStyle: "rectRounded",
        pointHoverRadius: 20,
        backgroundColor: "#B0B4FF",
      },
      {
        label: "Negative Mood",
        data: nm_data,
        pointRadius: 10,
        pointStyle: "rectRounded",
        pointHoverRadius: 20,
        backgroundColor: "#F8C998",
      },
      {
        label: "Positive Mood",
        data: pm_data,
        pointRadius: 10,
        pointStyle: "rectRounded",
        pointHoverRadius: 20,
        backgroundColor: "#74C9C1",
      },
      {
        label: "No Label",
        data: nl_data,
        pointRadius: 10,
        pointStyle: "rectRounded",
        pointHoverRadius: 20,
        backgroundColor: "#d3d3d3",
      },
    ],
  };
  const ScatterChart = () => {
    return <Scatter data={data} options={options} height={"85%"} />;
  };
  return (
    <CardLayout
      className="col-sm-12 col-md-12 col-lg-12"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid p-4">
        <div className="d-flex justify-content-between mb-4 mt-2">
          <label style={{ fontSize: "1.3rem", display: "flex", gap: "10px" }}>
            Journal Analysis
          </label>
          <div>
            <CTooltip content="Journal analysis labels as predicted by our Natural Language Processing (NLP) algorithm. A patient can have multiple journal entries on the same day showing different semantic tones.">
              <img
                style={{ cursor: "pointer" }}
                src={InfoIcon}
                height="15px"
                width="15px"
                alt="Information Icon"
              />
            </CTooltip>
          </div>
        </div>
        <ScatterChart />
      </div>
    </CardLayout>
  );
};

export default JournalAnalysis;
